const block = document.querySelector('.key-information');

if(block) {
    let items = block.querySelectorAll('ul li');
    if(items.length % 2 != 0) {
        block.querySelector('ul').classList.add('odd-items');
    }
}